import CTAButton from "@/components/base/CTAButton";

export default function FinalCta() {
  return (
    <section className="relative overflow-hidden bg-background-50 w-full px-4 md:px-6 lg:px-10 py-20 md:py-28">
      <div className="absolute -top-24 -right-24 w-[400px] h-[400px] rounded-full bg-primary-500/10 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-[400px] h-[400px] rounded-full bg-primary-500/5 blur-3xl" />

      <div className="relative mx-auto max-w-[1280px] text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold leading-tight tracking-tight text-foreground-950">
          Have a Problem Technology Can Solve?
        </h2>
        <p className="mt-6 text-lg text-foreground-600 leading-relaxed max-w-2xl mx-auto">
          Whether you need a website, a custom application, an automated
          workflow or a completely new digital solution, let's talk about what
          you're trying to achieve.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
          <CTAButton to="/contact" variant="primary" icon="ri-arrow-right-up-line">
            Start a Project
          </CTAButton>
          <CTAButton
            href="mailto:info@emchontechnologies.com"
            variant="outline"
            icon="ri-mail-line"
          >
            Talk to EMCHON
          </CTAButton>
        </div>
      </div>
    </section>
  );
}